/**埋点方法*/

/**自定义时间*/
export function sendRecord(eventCode,eventParams){

  const {aplus_queue} = window;
  aplus_queue.push({
    action: 'aplus.record',
    arguments: [eventCode, 'CLK', eventParams]
  });
}

/**自定义时间*/
export function sendPV(userData){
  const {aplus_queue} = window;
  aplus_queue.push({
    action: 'aplus.sendPV',
    arguments: [{ is_auto: false } , userData]
  });
}



// WEBPACK FOOTER //
// ./src/utils/buriedpoint.js